import { ProductCard } from './ProductCard';
import { Product } from '../types';

interface ProductListProps {
  products: Product[];
  onEdit: (product: Product) => void;
  onDelete: (product: Product) => void;
}

export function ProductList({ products, onEdit, onDelete }: ProductListProps) {
  if (products.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="text-6xl mb-4">📦</div>
        <h2 className="text-2xl font-medium text-gray-300 mb-2">Aucun produit ajouté</h2>
        <p className="text-gray-500 mb-6">Cliquez sur "Ajouter un produit" pour commencer à suivre des prix Amazon.fr</p>
        <button
          onClick={() => window.dispatchEvent(new CustomEvent('add-product'))}
          className="px-6 py-3 bg-green-600 hover:bg-green-500 text-white font-medium rounded-lg transition-colors"
        >
          ➕ Ajouter un produit
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-3 max-w-7xl mx-auto">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onEdit={() => onEdit(product)}
          onDelete={() => onDelete(product)}
        />
      ))}
    </div>
  );
}